import { render } from "./DashboardRelatorio.vue?vue&type=template&id=2da39fbe&scoped=true&style=padding%3A%2015px"
import script from "./DashboardRelatorio.vue?vue&type=script&lang=js"
export * from "./DashboardRelatorio.vue?vue&type=script&lang=js"

import "./DashboardRelatorio.vue?vue&type=style&index=0&id=2da39fbe&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da39fbe"]])

export default __exports__